import type { ReactNode } from 'react';
import { cn } from '../../lib/utils';

/** The documented shadcn shimmer utility; quiet effects are owned by the shared stylesheet. */
export function ShimmerText({ children, active = true, className }: { children: ReactNode; active?: boolean; className?: string }) {
  return <span className={cn('text-muted-foreground', active && 'shimmer', className)}>{children}</span>;
}
